import { render } from "./UiAppbarButton.vue?vue&type=template&id=0bce3e4c&ts=true"
import script from "./UiAppbarButton.vue?vue&type=script&lang=ts"
export * from "./UiAppbarButton.vue?vue&type=script&lang=ts"

import exportComponent from "/home/dima/Work/pioneer-lk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__